import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/proflow360/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/proflow360/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/var/www/proflow360/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/proflow360/src/app/components/HeroShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/proflow360/src/app/components/LandingFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/proflow360/src/app/components/LandingPricing.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/proflow360/src/components/ui/AppImage.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/proflow360/src/i18n/react.tsx");
